export default __webpack_public_path__ + "static/media/za.ae8f01fe.svg";